import {Component, OnInit} from '@angular/core';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {BackendService} from "../../services/backend/backend.service";
import {AlarmFilter, AlarmFilterMatcherResult, CoreSmartAlert, UpdatedDescription} from "../../models/core/alert-rule.model";
import {TelemetryDialogComponent} from "../telemetry-dialog/telemetry-dialog.component";
import { finalize, Subscription } from 'rxjs';
import { UtilsService } from 'src/app/services/utils/util.service';


@Component({
    selector: 'cc-smart-alert-details',
    standalone: false,
    templateUrl: './smart-alert-details.component.html',
    styleUrl: './smart-alert-details.component.scss'
})
export class SmartAlertDetailsComponent implements OnInit {
    alertData: CoreSmartAlert;
    isLoading = true;
    dataPointIdList: { id: string }[] = [];
    siteTimezone = '';
    descriptionToSave: string = '';
    enableTextEditor: boolean = false;
    isGeneratedFromTemplate = false;
    isSavingDescription = false;
    editDescriptionSubscription: Subscription;
    sharepointNumber: string = '';

    constructor(private ref: DynamicDialogRef,
                private config: DynamicDialogConfig,
                private backendService: BackendService,
                private utilsService: UtilsService,
                private dialogService: DialogService
    ) {
    }

    ngOnInit(): void {
        this.alertData = this.config.data;

        this.backendService.getAlertDetails(this.alertData.id).subscribe((response: CoreSmartAlert) => {
            this.siteTimezone = response.alarmConfig.site.timezone;
            this.alertData = {...this.alertData, ...response};
            this.iterateRulesToGetDataPointIdList(response.alarmFilterMatcherResult.rules);
            this.isLoading = false;
            this.isGeneratedFromTemplate = !!response.alarmTemplateId;
            this.descriptionToSave = response.alarmConfig.description;
            this.sharepointNumber = response.sharepointNumber || '';
        })
    }

    ngOnDestroy(): void {
        this.editDescriptionSubscription?.unsubscribe();
    }

    close(): void {
        this.ref.close();
    }

    showTelemetryDialog(): void {
        this.dialogService.open(TelemetryDialogComponent, {
            header: 'Data Point Analysis',
            contentStyle: {'padding': '0'},
            width: '90%',
            closable: false,
            data: {
                dataPoints: this.dataPointIdList,
                showPreview: false,
                alertData: this.alertData,
            }
        });
    }

    private iterateRulesToGetDataPointIdList(rules: AlarmFilter[]): void {
        if (!rules || !Array.isArray(rules)) {
            return;
        }

        for (const rule of rules) {
            // Process the current rule here
            if (rule.entityId) {
                this.dataPointIdList.push({id: rule.entityId});
            }

            // Recursively process nested rules
            if (this.ruleHasChildren(rule)) {
                this.iterateRulesToGetDataPointIdList(rule.rules);
            }
        }
    }

    private ruleHasChildren(rule: AlarmFilterMatcherResult): boolean {
        return rule.rules && Array.isArray(rule.rules);
    }

    editAlertDescription() {
        this.enableTextEditor = true;
    }

    cancelEditAlertDescription() {
        this.enableTextEditor = false;
        this.descriptionToSave = this.alertData.alarmConfig.description;
    }

    saveAlertDescription() {
        this.isSavingDescription = true;
        const payload: UpdatedDescription = {
            alarmConfigId: this.alertData.alarmConfig.id,
            description: this.utilsService.sanitizeQuillHtml(this.descriptionToSave)
        }
        this.editDescriptionSubscription?.unsubscribe();
        this.editDescriptionSubscription = this.backendService.updateRuleDescription(payload)
        .pipe(finalize(() => {
            this.isSavingDescription = false;
        }))
        .subscribe({
            next: (res) => {
                this.enableTextEditor = false;
            }
        })
    }
}
